import { render, staticRenderFns } from "./SocialList.vue?vue&type=template&id=365357f5&scoped=true&"
import script from "./SocialList.vue?vue&type=script&lang=js&"
export * from "./SocialList.vue?vue&type=script&lang=js&"
import style0 from "./SocialList.vue?vue&type=style&index=0&id=365357f5&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "365357f5",
  null
  
)

export default component.exports